const appContext = {
  WIDGET: 'widget',
  CONSUMER: 'consumer',
};

export default appContext;
export const isConsumer = (context) => context === appContext.CONSUMER;
export const isWidget = (context) => context === appContext.WIDGET;
